module.exports = __webpack_public_path__ + "img/sponsorJ21.e349898e.png";